<template>
  <div class="centerButtom">
    <div class="scan flex-row--c">
      <div class="scan-item" @click="open('first')" style="cursor: pointer">
        <img src="~@/assets/large/radar1.gif" alt="">
        <div class="flex-col--c">
          <span class="span-1">{{ this.report_data.clinic_report.yunzhensuo_cnt.toLocaleString() }}</span>
          <span class="span-2">云诊所</span>
        </div>
      </div>
      <div class="scan-item" @click="open('first')" style="cursor: pointer">
        <img src="~@/assets/large/radar1.gif" alt="">
        <div class="flex-col--c">
          <span class="span-1">{{ this.report_data.clinic_report.padzhensuo_cnt.toLocaleString() }}</span>
          <span class="span-2">Pad诊所</span>
        </div>
      </div>
      <div class="scan-item" @click="open('fourth')" style="cursor: pointer">
        <img src="~@/assets/large/radar1.gif" alt="">
        <div class="flex-col--c">
          <span class="span-1">{{ this.report_data.clinic_report.doctor_cnt.toLocaleString() }}</span>
          <span class="span-2">医生数</span>
        </div>
      </div>
      <div class="scan-item" @click="open('fifth')" style="cursor: pointer">
        <img src="~@/assets/large/radar1.gif" alt="">
        <div class="flex-col--c">
          <span class="span-1">{{ this.report_data.patient_report.patient_cnt.toLocaleString() }}</span>
          <span class="span-2">患者数</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { buildAppWebUrl } from '@/utils/appWebUrl'

export default {
  name: "centerButtom",
  data() {
    return {
      report_data: null,
    }
  },
  mounted() {
    this.get_report_data()
  },
  methods: {
    get_report_data() {
      this.$http.post(process.env.VUE_APP_API_HOST + "/get_report").then((res) => {
        this.report_data = res.data
      })
    },
    open(tab) {
      window.open(buildAppWebUrl(`/admin/admin_desc_view?act=${tab}`), '_blank', 'noopener,noreferrer');
    }
  }
}
</script>
<style lang='scss' scoped>
.centerButtom {
  flex-shrink: 0;
  height: 80px;
  width: 100%;
  //border: 1px solid #00a854;

  .scan {
    height: 100%;

    .scan-item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;

      img {
        width: 53px;
        margin-right: 10px;
      }

      .span-1 {
        font-size: 18px;
        color: #fff;
        font-weight: bold;
      }

      .span-2 {
        margin-top: 2px;
        font-size: 13px;
        color: #fff;
        opacity: .7;
      }
    }
  }
}
</style>
